export type TeamAnnouncementsTranslation = {
  label: string;
  markRead: string;
  more: {
    few: string;
    many: string;
    one: string;
  };
  showAll: string;
};

export const teamAnnouncementsTranslation: TeamAnnouncementsTranslation = {
  label: 'Ogłoszenie',
  markRead: 'Przeczytane',
  more: {
    few: '+{{count}} kolejne nieprzeczytane',
    many: '+{{count}} kolejnych nieprzeczytanych',
    one: '+1 kolejne nieprzeczytane',
  },
  showAll: 'Pokaż na pulpicie',
};
